/**
 * @generated SignedSource<<b97462d42d309e79fcc955b24137d411>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PopularSearchesSitemapLinksBlock_links$data = ReadonlyArray<{
  readonly path: string | null;
  readonly text: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  readonly " $fragmentType": "PopularSearchesSitemapLinksBlock_links";
}>;
export type PopularSearchesSitemapLinksBlock_links$key = ReadonlyArray<{
  readonly " $data"?: PopularSearchesSitemapLinksBlock_links$data;
  readonly " $fragmentSpreads": FragmentRefs<"PopularSearchesSitemapLinksBlock_links">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PopularSearchesSitemapLinksBlock_links",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData"
    }
  ],
  "type": "LinkData",
  "abstractKey": null
};

(node as any).hash = "c1449e59ea1abd1476916f0bada2535c";

export default node;
